// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSpinner_root__ZykMM","native":"IconSpinner_native__3TRGv"};